<template lang="pug">
v-content
  v-container
    v-toolbar.elevation-1(color="white")
      v-toolbar-title User List
      v-spacer
      v-btn(class="ma-2" color="primary" dark @click="addNewUser()") 
        v-icon() mdi-plus
        span Add New User
    UserList(v-if="$route.path == '/user-list'" :dataTable="getAllUser()")
</template>

<script>
import UserList from '../components/UserList.vue';
import { mapState } from "vuex";
export default {
  name: "UserMapping",
  components: {
    UserList,
  },
  data(){
    return{
      dataTable:{
        users:[],
        headers:[
          { text: 'Fullname', value: 'name',width: '15%' },
          { text: 'Email', value: 'email', align: ' d-none' },
          { text: 'Phone', value: 'phone', align: ' d-none' },
          { text: 'Department', value: 'department' },
          { text: 'Companies', value: 'companies', width: '20%'},
          { text: 'Location', value: 'location', width: '15%' },
          { text: 'Action', value: 'actions' },
        ]
      }
    }
  },
  mounted(){
    if (!this.dataUsers.isAdmin) {
      alert("Anda tidak punya hak akses untuk mengakses halaman ini");
      this.$router.push("my-approval-list");
    }
    this.$store.dispatch("fetchAllUser")
  },
  computed: {
    ...mapState(["userList","dataUsers"])
  },
  methods:{
    getAllUser(){
      this.dataTable.users = this.userList;
      return this.dataTable;
    },
    addNewUser() {
      this.$router.push("/add-user");
    },
  }
}
</script>